<template>
  <v-container id="app-customer-search">
    <!-- ***********************
    ********** SEARCH **********
    ************************ -->
    <template v-if="displaySearch">
      <div class="d-flex">
        <v-card
          light
          class="text-center ma-1 px-2 pt-1 pb-3"
        >
          <v-form @submit.prevent="searchCustomer">
            <div class="text-left">
              {{ $t('field.customer.mail_name_phone') }}
            </div>
            <v-text-field
              ref="search"
              v-model="searchValue"
              class="no-underline needsclick mb-1"
              style="font-size: 32px;font-weight: 700;"
              dense
              hide-details
            >
              <template v-slot:append>
                <v-icon
                  class="mt-1 pt-1"
                  @click="searchValue = ''"
                >
                  mdi-eraser
                </v-icon>
              </template>
            </v-text-field>
          </v-form>
        </v-card>
        <v-btn
          color="success"
          style="height: 80px"
          class="mt-1 mr-1"
          :disabled="disabled"
          @click="searchCustomer"
        >
          <v-icon large>
            mdi-magnify
          </v-icon>
        </v-btn>
      </div>
      <div class="pa-1 mt-2">
        <action-btn
          v-if="useCreationContactMyTerminal"
          :title="$t('field.customer.new_customer')"
          icon="mdi-account-plus"
          style="background-color: #5cbbf6 !important;"
          color="white"
          border-color="#5cbbf6"
          use-title-color
          @click="toNewCustomer"
        />
      </div>
    </template>

    <!-- *******************************
    ********** CUSTOMERS LIST **********
    ******************************** -->
    <template v-else>
      <v-card class="ma-1 py-1 px-2 d-flex">
        <v-text-field
          v-model="valueTextFilter"
          class="mx-5"
          :label="`Filtrer les ${customersList.length} résultats`"
          clearable
        />
      </v-card>
      <div
        class="bloc pull-bottom px-1"
        style="margin-bottom: 74px"
      >
        <action-btn
          v-if="useCreationContactMyTerminal"
          :title="$t('field.customer.new_customer')"
          icon="mdi-account-plus"
          style="background-color: #5cbbf6 !important;"
          color="white"
          border-color="#5cbbf6"
          use-title-color
          @click="toNewCustomer"
        />
      </div>

      <scrollable
        :action="!useCreationContactMyTerminal"
        :md="useCreationContactMyTerminal"
        class="pa-1"
      >
        <customer-card
          v-for="(customer, i) in customersFiltered"
          :key="i"
          :customer="customer"
          class="pa-2 mb-2"
          @click="cardAction"
        />
      </scrollable>
    </template>

    <bottom-action
      btn-valid-disabled
      btn-del
      btn-cancel
      @del="del"
      @cancel="cancel"
    />
  </v-container>
</template>

<script>
import CustomerCard from '@/components/customer/CustomerCard'

import { Carrier } from '@/modules/Carrier'
import { Scan } from '@/modules/Scan'
import { ActionEnum, IconEnum, TypeScanEnum } from '@/modules/Enums'
import { $alert } from '@/modules/Utils'

export default {
  name: 'CustomerSearchView',

  components: {
    CustomerCard
  },

  props: {
    scanProps: { type: Object, default: null },
    customers: { type: Array, default: null }
  },

  data () {
    return {
      IconEnum,
      searchValue: null,
      customersList: this.customers ? this.customers : [],
      valueTextFilter: null,
    }
  },

  computed: {
    useCreationContactMyTerminal () {
      return this.$store.getters.creationContactMyTerminal.length > 0 && this.$store.state.amount > 0
    },
    disabled () {
      return (this.searchValue === null || this.searchValue.length < 1)
    },
    displaySearch () {
      return this.customersList.length === 0
    },
    customersFiltered () {
      if (!this.valueTextFilter) return this.customersList

      let valueLowerCase = this.valueTextFilter.toNormalize()
      return this.customersList.filter(el => {
        let fullName = el.Nom + ' ' + el.Prenom
        let fullNameReverse = el.Prenom + ' ' + el.Nom

        return (
          fullName.toNormalize().includes(valueLowerCase)
          || fullNameReverse.toNormalize().includes(valueLowerCase)
          || el.Mail?.toNormalize().includes(valueLowerCase)
          || el.Adresse?.Pays?.toNormalize().includes(valueLowerCase)
          || el.Adresse?.Ville?.toNormalize().includes(valueLowerCase)
          || el.Telephone?.replace(new RegExp(' ', 'g'), () => '')
            ?.replace(new RegExp('\\+33', 'g'), () => '0').includes(valueLowerCase)
          || el.Telephone?.replace(new RegExp(' ', 'g'), () => '')
            ?.replace(new RegExp('0', 'g'), () => '+33').includes(valueLowerCase)
          || el.Telephone?.includes(valueLowerCase)
          || el.Telephone?.replace('+33', '0')?.replace(' ', '').includes(valueLowerCase)
          || el.Adresse?.CodePostal?.includes(valueLowerCase)
        )
      })
    }
  },

  mounted () {
    if (this.$store.state.teleparameters === null) {
      this.$router.replace('/')
    } else {
      this.$emit('title', this.$i18n.t('title.client_search'))
      setTimeout(() => {
        if (this.$refs.search) this.$refs.search.focus()
      }, 200)
    }
  },

  methods: {
    searchCustomer () {
      if (!this.disabled) {
        Carrier.searchContact(
          (response) => {
            if (response.length === 0) {
              $alert(this.$i18n.t('info.contact_no_result'), 'info')
            } else {
              this.customersList = response
            }
          },
          (error) => {
            $alert(error)
          },
          null,
          null,
          null,
          this.searchValue,
        )
      }
    },
    del () {
      if (this.displaySearch) {
        if (this.scanProps !== null) {
          this.$router.replace({ name: this.scanProps.route, params: this.scanProps })
        } else {
          this.$router.replace({ name: 'home', params: { reset: false } })
        }
      } else {
        this.customersList = []
      }
    },
    cancel () {
      this.$router.replace('/home')
    },
    cardAction (customer) {
      Carrier.getContactCards(
        customer.IDContact,
        (loyaltyCards) => {
          // Aucune carte
          if (loyaltyCards.length === 0) {
            // $alert(this.$i18n.t('info.no_loyalty_card'), 'warning')
            $alert(
              this.$i18n.t('info.no_loyalty_card'),
              'warning',
              'Souhaitez-vous ajouter une carte?',
              -1,
              [{
                title: 'Ajouter carte',
                color: 'success',
                click: () => {
                  this.$emit('title', this.$i18n.t('title.client_add_card'))

                  this.$router.replace({
                    name: TypeScanEnum[this.$store.state.favoriteScan].view,
                    params: {
                      action: ActionEnum.addClientCard,
                      customer: customer,
                      customers: this.customersList
                    }
                  })
                }
              },{
                title: 'Retour',
                color: 'info'
              }],
              null,
              false
            )
            this.$store.commit('loader', false)
          } else {
            // Carte trouvée, on fait un achat ou un badge infos
            Scan.badge(
              loyaltyCards[0].NumeroLong,
              this.$store.state.amount > 0 ? ActionEnum.loyalty : ActionEnum.badgeInformations,
              'P',
              () => {},
              (error) => { $alert(error) },
              false,
              false,
              null,
              null,
              null,
              false,
              this.customersList
            )
          }
        },
        (error) => {
          $alert(error)
        },
        false
      )
    },
    toNewCustomer () {
      this.$router.replace({ name: 'customer', params: { customers: this.customersList } });
    }
  }
}
</script>
